// Setting to zero allows the API to determine the default weight
export const DEFAULT_WEIGHT = 0;